<template>
    <hts-drawer
        v-model="visible"
        size="large"
        :title="$t('labels.businessModule.detail')"
        @close="closeOverSide">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <hts-form-textarea
                        v-model="dataBusiness.name"
                        :label="$t('labels.businessModule.name')"
                        :color="props.color"
                        readonly />
                    <hts-admincp-select-task
                        v-model="dataBusiness.tasks"
                        :selected-multiple="taskSelected"
                        multiple
                        :label="$t('labels.taskList')"
                        name="task"
                        prop="task"
                        key-id="_id"
                        key-label="name"
                        :filterable="true"
                        :clearable="true"
                        readonly />
                    <hts-form-input
                        v-model="dataBusiness.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description"
                        readonly />
                </hts-card>
            </div>
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
import { $api } from '#imports'
import { initEditBusiness } from '~/pages/admincp/business/ignore/imports/form'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  column: {
    type: Number,
    default: 1
  }
})

const visible = ref(false)
const dataBusiness: { [key: string]: any | null } = ref({ ...initEditBusiness })
const taskSelected = ref({} as { [key: string]: string })

const open = async (id: string) => {
  visible.value = true
  await getData(id)
}

const closeOverSide = () => {
  visible.value = false
  resetField()
}

const getData = async (id: string) => {
  const api = $urlSystem.business.getById
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value
  if (resData?.success) {
    dataBusiness.value = resData.data
    taskSelected.value = resData.data.tasks.map((task: any) => {
      return {
        _id: task._id,
        name: task.name
      }
    })
    dataBusiness.value.tasks = resData.data.tasks.map((task: any) => {
      return task._id
    })
  }
}

const resetField = () => {
  dataBusiness.value = { ...initEditBusiness }
  dataBusiness.value.task = []
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

defineExpose({
  open
})
</script>
fucntion/quote/status
